export const routeAdmin = (routes, checkAuth) => {
    routes.push(
        {
            path: "/empresas",
            component: () =>
                import(/* webpackChunkName: "empresas" */ "../pages/admin/Empresas"),
            beforeEnter: checkAuth
        },
        {
            path: "/empresa/:id",
            component: () =>
                import(/* webpackChunkName: "empresa" */ "../pages/admin/Empresa"),
            beforeEnter: checkAuth
        },
        {
            path: "/pings",
            component: () =>
                import(/* webpackChunkName: "pings" */ "../pages/admin/Pings"),
            beforeEnter: checkAuth
        },

        {
            path: "/cobertura",
            component: () =>
                import(/* webpackChunkName: "mapa_geral" */ "../pages/maps/MapaGeral")
        },
        {
            path: "/mapa-geral",
            component: () =>
                import(/* webpackChunkName: "mapa_geral" */ "../pages/maps/MapaGeral"),
            beforeEnter: checkAuth
        }
    );
};
